const Header = ({ children, bgColor = '' }) => {
    return (
        <div
            className={`h-[7vh] mb-5 w-full flex items-center justify-between bg-${
                bgColor ? bgColor : 'white'
            }`}
        >
            {children}
        </div>
    );
};

export default Header;
